import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const sarApi = {
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestSummary(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/sar_summary',
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestStatuses(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/sar_state/list',
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestTypes(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/types',
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestEffects(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/effects',
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {Object} parameters
   * @returns {AxiosPromise}
   */
  requestList(token, parameters) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams(parameters);
    return axios({
      url: '/list',
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      params,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {string} id
   * @returns {AxiosPromise}
   */
  requestDetail(token, id) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${id}`,
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {string} sarId
   * @returns {AxiosPromise}
   */
  requestDocuments(token, sarId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${sarId}/documents`,
      method: 'get',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestCreate({ token, data }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    return axios({
      url: '/individuals/newsar',
      method: 'post',
      baseURL: APIS.BASE_URL.SAR,
      headers,
      data,
      formSerializer: { indexes: null },
    });
  },
  /**
   *
   * @param {String} token
   * @param {string} sarId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestUpdate({ token, sarId, data }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    return axios({
      url: `/individuals/${sarId}/update`,
      method: 'put',
      baseURL: APIS.BASE_URL.SAR,
      headers,
      data,
      formSerializer: { indexes: null },
    });
  },
  /**
   *
   * @param {String} token
   * @param {string} documentId
   * @returns {AxiosPromise}
   */
  requestDeleteDocument(token, documentId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/documents/${documentId}`,
      method: 'delete',
      baseURL: APIS.BASE_URL.SAR,
      headers,
    });
  },
};

export default sarApi;
